import { useQuery } from "@tanstack/react-query";
import { usePropertyApi } from "./property.api";
import { propertyQueryKeys } from "./property.queryKeys";

export function usePropertyChildrenQuery(propertyTicker: string, enabled = true) {
  const { getPropertyChildren } = usePropertyApi();

  return useQuery({
    queryKey: propertyQueryKeys.children(propertyTicker),
    queryFn: () => getPropertyChildren(propertyTicker),
    enabled: enabled && !!propertyTicker,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
  });
}
